<template>
    <div>
        <v-title title="基本信息" style="margin-left: -15px"></v-title>
        <el-form ref="form" :model="form" label-width="70px" label-position="left" size="mini">
            <el-row>
                <el-col :span="16" class="flex aic">
                    <div class="ml5">
                        <el-input placeholder="请输入身份证信息 / 病历号" size="mini"></el-input>
                    </div>
                    <div class="ml5">
                        <el-button type="primary" size="mini">查询</el-button>
                    </div>
                </el-col>
            </el-row>
            <el-row class="mt20" :gutter="20">
                <el-col :span="7">
                    <el-form-item label="患者姓名">
                        <el-input v-model="form.name" placeholder="身份证读取/手工"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="3">
                    <el-form-item label="性别" label-width="40px">
                        <el-select v-model="form" placeholder="性别">
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :span="3">
                    <el-form-item label="年龄" label-width="40px">
                        <el-input v-model="form.name" placeholder="年龄"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="11">
                    <el-form-item label="患者病历号" label-width="90px">
                        <el-input v-model="form.name" placeholder="自动检索到病历号，可能有多个"></el-input>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row :gutter="20">
                <el-col :span="7">
                    <el-form-item label="身份证">
                        <el-input v-model="form.name" placeholder="身份证读取/手工"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="4">
                    <el-form-item label="电话" label-width="40px">
                        <el-input v-model="form.name" placeholder="HIS中导入/手工"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="3">
                    <el-form-item label="婚姻" label-width="40px">
                        <el-select v-model="form" placeholder="婚姻">
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :span="5">
                    <el-form-item label="职业" label-width="40px">
                        <el-select v-model="form" placeholder="请选择职业">
                        </el-select>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="14">
                    <el-form-item label="家庭住址">
                        <el-input v-model="form.name" placeholder="请输入详细地址"></el-input>
                    </el-form-item>
                </el-col>
            </el-row>
        </el-form>
    </div>
</template>

<script>
  import VTitle from "../common/v-title";

  export default {
    name: "diagnose-base-form",
    components: {VTitle},
    props: {
      value: {
        type: Number,
        default: 0
      },
    },
    data() {
      return {
        form: {}
      }
    },
  }
</script>

<style scoped lang="scss">

</style>
